import { useNavigate } from '@tanstack/react-router';
import { Info } from 'lucide-react';
import { Button } from '@ludolio/shared-ui';
import { useAuthStore } from '@/stores/authStore';
import { useDemoStore } from '@/stores/demoStore';

export function DemoBanner() {
  const navigate = useNavigate();
  const isDemoMode = useDemoStore((state) => state.isDemoMode);
  const logout = useAuthStore((state) => state.logout);

  if (!isDemoMode) return null;

  return (
    <div className="sticky top-0 z-40 w-full bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100">
      <div className="container relative mx-auto flex max-w-7xl items-center justify-center px-4 py-2">
        <div className="flex max-w-full items-center justify-center gap-2 px-16 text-center text-sm sm:px-24">
          <Info className="h-4 w-4 flex-shrink-0" />
          <span><span className="font-semibold">Demo mode</span> — you're exploring with sample instructor data. Changes won't be saved.</span>
        </div>
        <Button size="sm" variant="ghost" className="absolute right-4 top-1/2 h-7 -translate-y-1/2 rounded-md border border-amber-300 bg-amber-50 px-2.5 text-xs font-medium text-amber-800 shadow-none hover:bg-amber-100 hover:text-amber-950 dark:border-amber-700/80 dark:bg-amber-950/30 dark:text-amber-100 dark:hover:bg-amber-900/50 dark:hover:text-white" onClick={async () => { await logout(); navigate({ to: '/' }); }}>
          Exit demo
        </Button>
      </div>
      <svg aria-hidden="true" viewBox="0 0 28 20" className="pointer-events-none absolute left-0 top-full -mt-px h-5 w-7 text-amber-100 dark:text-amber-900/40"><path fill="currentColor" d="M0 0V20Q0 6 28 0Z" /></svg>
      <svg aria-hidden="true" viewBox="0 0 28 20" className="pointer-events-none absolute right-0 top-full -mt-px h-5 w-7 text-amber-100 dark:text-amber-900/40"><path fill="currentColor" d="M28 0V20Q28 6 0 0Z" /></svg>
    </div>
  );
}